import { glyphOf } from '../types';

/** One glyph per type, the same as the list's map (board 4); a pin without one. */
export function CategoryIcon({ type }: { readonly type: string | null }) {
  const Icon = glyphOf(type);
  return <Icon aria-hidden="true" className="size-4" />;
}
